import { render, staticRenderFns } from "./Annual.vue?vue&type=template&id=2c68dceb&scoped=true&"
import script from "./Annual.vue?vue&type=script&lang=js&"
export * from "./Annual.vue?vue&type=script&lang=js&"
import style0 from "./Annual.vue?vue&type=style&index=0&id=2c68dceb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c68dceb",
  null
  
)

export default component.exports